// extracted by mini-css-extract-plugin
export var layout_footer = "footer-module--layout_footer--95af7";